import React from 'react';
import cx from 'classnames';

import { GreenButton, WhiteButton } from '@marketing/components/buttons';

import ClockIcon from './assets/clock_icon.svg';
import styles from './style.module.scss';

interface Props {
  answerChoices: string[];
  prompt: string;
  subject: string;
}

const InteractivePrompt: React.FC<Props> = (props) => {
  return (
    <div className="d-flex">
      <div className="d-flex flex-column">
        <div className="u-margin-B-m u-padding-L-s">
          <strong>{props.subject}</strong>
        </div>

        <div
          className={cx(styles.promptContainer, 'flex-1')}
          style={{
            background: '#F9FAFB',
            border: '1px solid rgba(92, 92, 92, 0.15)',
            borderRadius: '16px 0 0 0',
            color: '#5C5C5C',
            fontSize: 14,
            padding: 20
          }}
        >
          {props.prompt}
        </div>

        <div
          style={{
            borderColor: 'rgba(92, 92, 92, 0.15)',
            borderRadius: '0 0 0 16px',
            borderStyle: 'solid',
            borderWidth: '0 0 1px 1px',
            padding:'15px 20px'
          }}
        >
          <WhiteButton disabled href="#" size="sm">End Practice and See Results</WhiteButton>
        </div>
      </div>

      <div className="d-flex flex-1 flex-column">
        <div className="align-items-end d-flex gap-xs u-margin-B-m u-padding-L-s">
          <div>
            <img alt="Clock icon" height="17px" src={ClockIcon} width="17px" />
          </div>

          <div style={{ color: '#8D8C8E', fontSize: 14 }}>
            <strong>0:14</strong>
          </div>
        </div>

        <div
          className="d-flex flex-1 flex-column gap-xs"
          style={{
            borderColor: 'rgba(92, 92, 92, 0.15)',
            borderRadius: '0 16px 0 0',
            borderStyle: 'solid',
            borderWidth: '1px 1px 1px 0',
            padding: 20
          }}
        >
          {
            props.answerChoices.map((answerChoice) => (
              <div
                key={answerChoice}
                className="align-items-center d-flex flex-1"
                style={{ fontSize: 14, gap: 8 }}
              >
                <input
                  className={styles.radioButton}
                  disabled
                  id={`answerChoice-${answerChoice}`}
                  name="answerChoice"
                  style={{ margin: 0 }}
                  type="radio"
                />

                <label className="flex-1 u-margin-A-n" htmlFor={`answerChoice-${answerChoice}`}>
                  <strong>{answerChoice}</strong>
                </label>
              </div>
            ))
          }
        </div>

        <div
          style={{
            borderColor: 'rgba(92, 92, 92, 0.15)',
            borderRadius: '0 0 16px 0',
            borderStyle: 'solid',
            borderWidth: '0 1px 1px 0',
            padding:'15px 20px'
          }}
        >
          <GreenButton disabled href="#" size="sm">Submit Answer</GreenButton>
        </div>
      </div>
    </div>
  );
};

export default InteractivePrompt;
